import { decorate, observable, action, computed, toJS } from "mobx";
import { NO_BLANKS } from "../Constants";
import AbstractStore from "../AbstractStore";

class Store extends AbstractStore {
    selectedOptions = new Set()
    searchText = ""
    values = []

    isCountSortAscending = 1
    isValueSortAscending = 1
    loadValues = async () => {
        this.isCountSortAscending = 1;
        this.isValueSortAscending = 1;
        this.isLoading = true;
        this.values = await this.agGridProps.values(this.agGridProps);
        const blankValueIndex = this.values.findIndex(x => x[this.dataIndex] === "")
        const blankValue = blankValueIndex > -1 ? this.values.splice(blankValueIndex, 1) : [{[this.dataIndex]:"",count:0}];

        const noBlankCount = this.values.reduce((res, val) => + val.count + res, 0);

        this.values = [...blankValue, { [this.dataIndex]: NO_BLANKS, count: noBlankCount }, ...this.values];
        this.isLoading = false;
    }

    get filteredValues() {
        if (!this.searchText) {
            return this.values;
        }
        const regExp = new RegExp(this.searchText, "i");

        return this.values.filter(val => val[this.dataIndex].match(regExp));
    }

    invertSelection() {
        let currentlySelectedOptions = new Set(this.selectedOptions);
        this.selectedOptions.clear();
        this.filteredValues.forEach((value) => {
            if (!currentlySelectedOptions.has(value[this.dataIndex]) && value[this.dataIndex] != '__no_blanks') {
                this.selectedOptions.add(value[this.dataIndex]);
            }
        });
    }
    setModel = model => {
        if (model?.values) {
            this.selectedOptions = new Set(model.values);
        } else {
            this.selectedOptions.clear();
            this.searchText="";
        }
    }
}

decorate(Store, {
    selectedOptions: observable,
    values: observable,
    isLoading: observable,
    searchText: observable,

    filteredValues: computed
});

export default Store;
